module.exports = __webpack_public_path__ + "img/White Mocha Frappe.39ddb431.svg";